var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1F381(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD888",
    d: "M33 31c0 2.2-1.8 4-4 4H7c-2.2 0-4-1.8-4-4V14c0-2.2 1.8-4 4-4h22c2.2 0 4 1.8 4 4v17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD888",
    d: "M36 11c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h28c2.2 0 4 1.8 4 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCAB40",
    d: "M3 15h30v2H3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA2F47",
    d: "M19 3h-2c-1.657 0-3 1.343-3 3v29h8V6c0-1.656-1.343-3-3-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA2F47",
    d: "M16 7c1.1 0 1.263-.516.361-1.147L9.639 1.147c-.902-.631-2.085-.366-2.631.589L4.992 5.264C4.446 6.219 4.9 7 6 7h10zm4 0c-1.1 0-1.263-.516-.361-1.147l6.723-4.706c.901-.631 2.085-.366 2.631.589l2.016 3.527C31.554 6.219 31.1 7 30 7H20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F381);
export default __webpack_public_path__ + "static/media/1f381.4bc9e31b96f92a347ae964a80a424949.svg";
export { ForwardRef as ReactComponent };